<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <radio-list
        :name="'navigation_page'"
        :items="rubrics"
        v-model="rubric"
      />
      <pages v-if="loaded[1] === true" v-show="rubric == 1" />
      <pages-group v-if="loaded[2] === true" v-show="rubric == 2" />
    </div>
  </card>
</template>

<script>
import RadioList from "../components/Filters/RadioList";
import Pages from "../components/Pages/Pages";
import PagesGroup from "../components/Pages/PagesGroup";

export default {
  name: "PagesPage",
  components: {
    RadioList,
    Pages,
    PagesGroup,
  },
  created() {
    if (this.$store.state.navs[this.$options.name]) this.getRubrics();
  },
  methods: {
    getRubrics() {
      this.$http
        .get(`pages/navigation`)
        .then((response) => {
          this.rubrics = response.data;
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },
  
  },
  watch:{
    rubric(val){
      this.loaded[val] = true
    }
  },
  data() {
    return {
      rubrics: [],
      rubric: 1,
      loaded: {
        1: true,
      },
    };
  },
};
</script>
<style>
</style>
